import { PLOT_CHILD_CATEGORY } from "@/config/const";
import Colors from "@/config/Colors";

export const createFeatures = plot => {
  const features = [];
  plot.features.forEach(feature => {
    const current = new Date().getTime() / 1000;
    if ((feature.properties.start_date && feature.properties.start_date > current) ||
      (feature.properties.end_date && feature.properties.end_date <= current)) {
      return;
    }
    features.push({
      type: "Feature",
      properties: {
        category: feature.properties.category,
        title: feature.properties.title,
        id: feature.properties.id,
        icon: PLOT_CHILD_CATEGORY.properties[feature.properties.child_category].icon,
        color: Colors.getPlotSubCategoryColor(feature.properties.child_category)
      },
      geometry: getGeometry(feature)
    });
  });
  return features;
};

export const getGeometry = feature =>  {
  if (feature.geometry.type === "Point" && feature.geometry.coordinates.length > 2) {
    const coordinates = [[]];
    feature.geometry.coordinates.forEach(function (value, index) {
      if (index % 2 === 0) {
        coordinates[0].push([
          feature.geometry.coordinates[index],
          feature.geometry.coordinates[index + 1]
        ]);
      }
    });
    // 終点に始点を追加
    coordinates[0].push(coordinates[0][0]);
    return {
      type: "Polygon",
      coordinates: coordinates
    };
  }
  if (feature.geometry.type === "Polygon" && feature.geometry.coordinates[0].length === 1) {
    return {
      type: "Point",
      coordinates: [
        feature.geometry.coordinates[0][0][0],
        feature.geometry.coordinates[0][0][1]
      ]
    };
  }
  if (feature.geometry.type === "Polygon") {
    const coordinates = [[]];
    coordinates[0] = feature.geometry.coordinates[0].slice();
    // 終点に始点を追加
    coordinates[0].push(coordinates[0][0]);
    return {
      type: "Polygon",
      coordinates: coordinates
    };
  }

  return feature.geometry;
};

export const createEditFeatureForPoint = (point, index, childCategoryId, length) => {
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: point,
    },
    properties: {
      length: length,
      index: index,
      icon: childCategoryId
        ? PLOT_CHILD_CATEGORY.properties[childCategoryId]
          .icon
        : ""
    }
  }
};

export const createEditFeatureForPolygon = (coordinates) => {
  return {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [coordinates]
    }
  }
};
